import './styles/index.css';
import '@splidejs/react-splide/css';
import '@stream-io/stream-chat-css/dist/css/index.css';

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import App from './App';
import ErrorBoundary from './components/error/ErrorBoundary';
import { initConfig } from './config';
import {
  emitTelemetry,
  initializeBrowserObservability,
  initializeCloudWatchRum,
  initializeFetchObservability,
} from './observability';
import reportWebVitals from './reportWebVitals';
import { router } from './routes/routes';

initConfig();
void initializeCloudWatchRum();
initializeFetchObservability();
initializeBrowserObservability(router);

const root = createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </StrictMode>
);

reportWebVitals(metric => {
  emitTelemetry('frontend.web-vital', {
    delta: metric.delta,
    id: metric.id,
    metric: metric.name,
    value: metric.value,
  });
});
